import React, { useState } from "react";

const SpecificationBarcode = ({ formData, setFormData }) => {
  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const [type, setType] = useState("barcode"); // barcode / qrcode

  return (
    <div className="border border-gray-300 p-4 rounded-md bg-gray-50">
      <div className="grid grid-cols-3 gap-4">
        {/* LEFT — Specifications box */}
        <div className="col-span-2">
          <textarea
            className="w-full h-[280px] border border-gray-300 rounded-md bg-white p-3 text-sm placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500 outline-none resize-none"
            placeholder="Enter details here..."
            onChange={(e) => handleChange("desc1", e.target.value)}
            value={formData.desc1 || ""}
          ></textarea>
        </div>

        {/* RIGHT — Barcode/QR Section */}
        <div className="col-span-1 flex flex-col items-center justify-start space-y-4">
          {/* Print Button */}
          <button className="bg-green-300 hover:bg-green-400 px-4 py-2 rounded shadow border border-green-500">
            Barcode Print
          </button>

          {/* Radio Options */}
          <div className="flex items-center space-x-6">
            <label className="flex items-center space-x-1">
              <input
                type="radio"
                checked={type === "barcode"}
                onChange={() => setType("barcode")}
              />
              <span className="text-sm ml-4">Barcode</span>
            </label>

            <label className="flex items-center space-x-2">
              <input
                type="radio"
                checked={type === "qrcode"}
                onChange={() => setType("qrcode")}
              />
              <span className="text-sm ml-4">QR Code</span>
            </label>
          </div>

          {/* Preview */}
          <div className="mt-4">
            {type === "barcode" ? (
              <>
                {/* BARCODE SVG */}
                <svg
                  version="1.1"
                  width="140px"
                  height="120px"
                  viewBox="0 0 1200 1200"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0,99.87v1000.26h100.26V99.87H0z M186.135,99.87v1000.26h24.089V99.87h-24.089z 
                    M244.018,99.87v1000.26h76.219V99.87h-76.219z M397.676,99.87v1000.26h32.525V99.87h-32.525z 
                    M516.125,99.87v1000.26h24.041V99.87h-24.041z M550.504,99.87v1000.26h99.626V99.87h-99.626z 
                    M709.915,99.87v1000.26h50.18V99.87h-50.18z M858.94,99.87v1000.26h11.118V99.87H858.94z 
                    M946.57,99.87v1000.26h33.501V99.87H946.57z M1065.946,99.87v1000.26h24.09V99.87h-24.09z 
                    M1100.374,99.87v1000.26H1200V99.87h-99.626z"
                  />
                </svg>
              </>
            ) : (
              <>
                {/* QR CODE SVG */}
                <svg
                  width="140px"
                  height="140px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3 9h6V3H3zm1-5h4v4H4zm1 1h2v2H5zm10 4h6V3h-6zm1-5h4v4h-4zm1 1h2v2h-2zM3 21h6v-6H3zm1-5h4v4H4zm1 1h2v2H5zm15 2h1v2h-2v-3h1zm0-3h1v1h-1zm0-1v1h-1v-1zm-10 2h1v4h-1v-4zm-4-7v2H4v-1H3v-1h3zm4-3h1v1h-1zm3-3v2h-1V3h2v1zm-3 0h1v1h-1zm10 8h1v2h-2v-1h1zm-1-2v1h-2v2h-2v-1h1v-2h3zm-7 4h-1v-1h-1v-1h2v2zm6 2h1v1h-1zm2-5v1h-1v-1zm-9 3v1h-1v-1zm6 5h1v2h-2v-2zm-3 0h1v1h-1v1h-2v-1h1v-1zm0-1v-1h2v1zm0-5h1v3h-1v1h-1v1h-1v-2h-1v-1h3v-1h-1v-1zm-9 0v1H4v-1zm12 4h-1v-1h1zm1-2h-2v-1h2zM8 10h1v1H8v1h1v2H8v-1H7v1H6v-2h1v-2zm3 0V8h3v3h-2v-1h1V9h-1v1zm0-4h1v1h-1zm-1 4h1v1h-1zm3-3V6h1v1z" />
                </svg>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecificationBarcode;
